import { render, staticRenderFns } from "./ContactInfoFrom.vue?vue&type=template&id=6009c008&"
import script from "./ContactInfoFrom.vue?vue&type=script&lang=js&"
export * from "./ContactInfoFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports